// FADE IN ANIMATION
$(".js-fade-in-row").addClass('js-fade-in-row--hidden');
function scrollRowAnimation(){	
	$(".js-fade-in-row").each(function(){
		var divPos = $(this).offset().top;
		var topOfWindow = $(window).scrollTop();
		var height = $(window).height();

		if (divPos < topOfWindow + height - 200) {
			$('.js-fade-in-row').children().each(function (index) {
				var $this = $(this);
				setTimeout(function () {
					$this.addClass('js-fade-in-row--visible');
				}, 300 * index );
			});
		}
	});	
}


$(document).ready(function(){
	// console.log("hello 👋")

	scrollRowAnimation();

	// NAVIGATION

	$('.js-nav-trigger').click(function() {
		$(this).attr('aria-expanded', 'true');
		$('.site-nav').addClass('site-nav--active');
	});

	$('.js-nav-close').click(function() {
		$('.site-nav').removeClass('site-nav--active');
		$('.site-nav__item').removeClass('active-parent');
		$('.js-nav-trigger').attr('aria-expanded', 'false');
	});

	// $('.site-nav__item').on('click', function (event) {
	// 	if ($(this).children('ul').length > 0) {
	// 		event.preventDefault();
	// 		$(this).siblings().removeClass('active-parent');
	// 		$(this).addClass('active-parent');
	// 		$(this).children('ul').click(function (e) {
	// 			e.stopPropagation();
	// 		});
	// 	}
	// });

	// Commented out as duplicate of what is above?
	// $('.js-nav-close').click(function() {
	// 	$('.site-nav').removeClass('site-nav--active');
	// });

	if ($(window).width() < 800) {
		$('.js-nav-dropdown').slideUp();

		$('.js-dropdown-toggle').click(function() {
			$(this).children('.js-nav-dropdown').slideToggle();
			$(this).toggleClass('site-nav__dropdown-trigger--active');
		});	
	}

	// SLIDERS

	$('.js-hero-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		pauseOnHover: false,
		infinite: true
	});

	$('.js-col-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		// autoplay: true,
		// autoplaySpeed: 2000,
		dots: false,
		infinite: false,
		responsive: [
			{
			  breakpoint: 850,
			  settings: {
				slidesToShow: 3
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 2
			  }
			},
			{
				breakpoint: 390,
				settings: {
				  slidesToShow: 1
				}
			}
		  ]
	});
});


$(window).scroll(function(){  
	scrollRowAnimation();
});

$(window).resize(function(){
	scrollRowAnimation();
});